import { DndContext, useDroppable } from "@dnd-kit/core";
import { createComponent } from "@opendash/state";
import { Spin } from "antd";
import React from "react";
import { CanbanViewType } from "..";
import type { ParseFilterState } from "../../../state/ParseFilterState";
import { CanbanState } from "../states/CanbanView.state";
import { BoardDiv, BoardInnerDiv } from "./CanbanView.layout";
import CanbanViewColumn from "./CanbanViewColumn";

interface Props {
  state: ParseFilterState;
  view: CanbanViewType;
}

export const CanbanView = createComponent<Props>(function CanbanView({
  state,
  view,
}) {
  const canbanState = React.useMemo(() => new CanbanState(state), [state]);
  const { setNodeRef, isOver } = useDroppable({
    id: "canbanview",
  });

  if (canbanState.loading) {
    return <Spin style={{ width: "100%", textAlign: "center" }} />;
  }

  canbanState.columnsArray;

  return (
    <BoardDiv ref={setNodeRef}>
      <DndContext onDragEnd={(result) => canbanState.onDragEnd(result)}>
        <BoardInnerDiv>
          {/* <SortableContext items={canbanState.columnsArray.map((c) => c.key)}> */}
          {/* <SortableContext
            items={canbanState.columns.flatMap((column) =>
              column.cards.map((card) => card.key)
            )}
            strategy={
              canbanState.cardsSortable
                ? rectSortingStrategy
                : horizontalListSortingStrategy
            }
          > */}
          {canbanState.columnsArray.map((column) => (
            <CanbanViewColumn
              key={column.key}
              view={view}
              state={state}
              column={column}
              isSortable={canbanState.columnsSortable}
            />
          ))}
          {/* </SortableContext> */}
          {/* </SortableContext> */}
        </BoardInnerDiv>
      </DndContext>
    </BoardDiv>
  );
});
